import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Svg = styled.svg`
  fill: ${({ theme }) => theme.colors.TextBeta};
`;

const Picture = ({ width, height, ...rest }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 72 72" {...rest}>
      <path
        d="M23.81,45.14c0,6.73,5.46,12.19,12.19,12.19s12.19-5.46,12.19-12.19S42.73,32.95,36,
        32.95 C29.27,32.96,23.82,38.41,23.81,45.14z M36,37.02c4.49,0,8.12,3.64,8.12,8.12s-3.64,
        8.13-8.12,8.13s-8.13-3.64-8.13-8.13 S31.51,37.02,36,37.02z M60.37,
        28.89v4.06h-8.12v-4.06H60.37z M64.44,37.02h4.06v4.06h-4.06V37.02z M64.44,
        45.14h4.06v4.06h-4.06 V45.14z M68.5,
        20.77v12.19h-4.06v-8.13H46.6l-2.03-8.12H36v-4.06h11.74l2.03,8.13H68.5z
        M64.44,53.27h4.06v12.19h-65V34.98h4.06 v26.41h56.87V53.27z M11.63,
        34.98h12.19v-8.12h8.13V14.67h-8.13V6.55H11.63v8.12H3.5v12.19h8.13V34.98z
        M7.56,22.8v-4.06h8.13v-8.12 h4.06v8.12h8.12v4.06h-8.12v8.13h-4.06V22.8H7.56z"
      />
    </Svg>
  );
};

Picture.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

export default Picture;
